import { useQuery, useQueryClient } from '@tanstack/react-query';

import { openOffersQuery } from '../api/offers.ts';
import { OfferRow } from './offer-row.tsx';

// CB-REQ CRW-04 at v1.994 – v1.995 (crew part 3d): offers with places still taking answers, across
// jobs and held days, soonest first — beside the shifts to confirm and the held days to assign.

export function OffersOpen({ mayManage, seesPrices }: { mayManage: boolean; seesPrices: boolean }) {
  const open = useQuery(openOffersQuery);
  const queryClient = useQueryClient();
  const refresh = async () => {
    await queryClient.invalidateQueries({ queryKey: ['shift-offers'] });
    await queryClient.invalidateQueries({ queryKey: ['jobs'] });
    await queryClient.invalidateQueries({ queryKey: ['roster'] });
  };
  if (!open.data || open.data.length === 0) return null;
  return (
    <section aria-labelledby="offers-open" className="flex flex-col gap-3">
      <h2 id="offers-open" className="section-title">
        Offers open
      </h2>
      <ul className="flex flex-col gap-2">
        {open.data.map((o) => (
          <OfferRow
            key={o.id}
            offer={o}
            editable={mayManage}
            seesPrices={seesPrices}
            showJob
            onChanged={refresh}
          />
        ))}
      </ul>
    </section>
  );
}
